import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Chapter, SectionHead, Reveal } from "@/components/Reveal";

const FAQS = [
  {
    q: "What is Synaphy?",
    a: "Synaphy is a Physical World Intelligence Network - a distributed network that captures, verifies and transforms real-world observations into structured, AI-ready intelligence. It begins with Road & Mobility Intelligence and is designed to expand into vehicles, buildings, electrical, HVAC, industrial and infrastructure layers.",
  },
  {
    q: "What is physical world intelligence?",
    a: "Physical World Intelligence is structured, verified data about the real world - the condition of roads, the state of infrastructure, and how physical environments change over time. The digital world has search engines and data networks; Synaphy is building the equivalent intelligence layer for the physical world.",
  },
  {
    q: "Why start with roads?",
    a: "Roads change every day - potholes appear, signs change, lane markings fade, construction moves. Traditional datasets cannot continuously observe everything. Road & Mobility Intelligence is the highest-frequency, highest-value starting point for a continuously refreshed physical-world data layer.",
  },
  {
    q: "How can I join?",
    a: "Two ways: join the free Founding waitlist to reserve your Founding ID and get early Pilot access, or apply to become one of 100 Founding Verifiers who will help operate the network's trust layer.",
  },
  {
    q: "Is Synaphy live?",
    a: "Synaphy is currently in its Founding / pre-launch phase. The Pilot contribution system is not live yet. This website is the 90-day Founding phase gateway into the network.",
  },
  {
    q: "When does the Pilot phase start?",
    a: "The Pilot phase follows the 90-day Founding phase. Founding members and Founding Verifiers will be the first to receive onboarding details and access.",
  },
  {
    q: "What is a Founding Verifier?",
    a: "Founding Verifiers are early network operators responsible for helping verify and attest to physical-world data once the network enters the Pilot phase - running verifier infrastructure, verifying observations, attesting to data authenticity, and protecting network integrity. The Founding cohort is limited to 100 positions.",
  },
  {
    q: "How are verifiers selected?",
    a: "Through an application and due-diligence process that considers technical background, node and infrastructure experience, and cloud experience. Participation is subject to technical, legal and protocol requirements, and terms are provided during the application process.",
  },
  {
    q: "Is there a payment to join the free waitlist?",
    a: "No. Joining the Founding waitlist is completely free and always will be.",
  },
  {
    q: "Do I need to pay anything to join?",
    a: "No. The Founding waitlist is completely free - reserve your position with just your name and email.",
  },
  {
    q: "How will contributors be rewarded?",
    a: "Future network rewards will depend on the final protocol design and actual network contribution. Synaphy does not guarantee income or returns.",
  },
  {
    q: "What data does Synaphy collect?",
    a: "The network is designed around physical-world observations: location, time, road condition, traffic infrastructure, vehicle context, environment, visual observations and motion signals. Not every listed data source is live today - future capabilities are clearly labeled as planned on this website.",
  },
  {
    q: "How is privacy protected?",
    a: "Synaphy is privacy-first by design: identity and data separation, automatic redaction of faces and license plates where applicable, controlled access so verifiers and applications receive only the data necessary for their role, and encryption during transmission and storage. Privacy architecture will evolve alongside the network.",
  },
  {
    q: "Do verifiers work manually 24/7?",
    a: "No. The verifier node is designed to operate continuously and automatically. Operators monitor infrastructure, maintain availability and respond to alerts when required.",
  },
  {
    q: "Are rewards guaranteed?",
    a: "No. Synaphy does not offer fixed returns, fixed daily income, guaranteed monthly payouts or guaranteed earnings of any kind. Future network rewards will depend on the final protocol design, network economics and actual verified contribution.",
  },
  {
    q: "What happens to my data?",
    a: "Waitlist registration stores your name, email and optional mobile number so we can contact you about Founding access. Network data architecture is designed around identity separation, PII redaction where applicable, controlled access and encryption in transit and storage.",
  },
  {
    q: "Is the network live?",
    a: "Synaphy is in its Founding / pre-launch stage, so contribution systems and network economics are not live yet. Details will be published only when finalized.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="relative py-28 sm:py-40 bg-ink-950" data-testid="section-faq">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Chapter label="FAQ" />
        <SectionHead title={"Questions, answered."} />
        <Reveal delay={0.2}>
          <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="border-b border-white/5"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="py-6 text-left text-base sm:text-lg font-medium text-mist hover:text-signal-cyan hover:no-underline transition-colors [&[data-state=open]]:text-signal-cyan">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-7 text-[15px] leading-relaxed text-steel">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
